var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetafek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#EBC500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 37.5C31.9036 37.5 37.5 31.9036 37.5 25C37.5 18.0964 31.9036 12.5 25 12.5C18.0964 12.5 12.5 18.0964 12.5 25C12.5 31.9036 18.0964 37.5 25 37.5ZM31.9885 28.454C29.9257 28.454 29.1198 27.0724 29.1198 25.0672C29.1198 22.9468 30.1272 21.5461 32.094 21.5461C33.418 21.5461 34.0129 22.1313 34.1951 22.3328L33.2357 23.3978C33.015 23.1291 32.6984 22.7837 31.9885 22.7837C31.0866 22.7837 30.6261 23.4649 30.6261 24.9712C30.6261 26.3624 31.1058 27.1971 32.1132 27.1971C32.7368 27.1971 33.111 26.8709 33.3125 26.631L34.1184 27.6672C33.8306 28.0126 33.1494 28.454 31.9885 28.454ZM19.3355 25.2591L18.0594 21.6324H15.8047V28.358H17.148V23.3786H17.2055L18.683 27.5521H19.8919L21.3886 23.3786H21.427V28.358H22.8278V21.6324H20.6307L19.3738 25.2591H19.3355ZM25.8638 28.358V25.8347H28.0321V24.6258H25.8638V22.8413H28.3871V21.6324H24.4054V28.358H25.8638Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetafek);
export default __webpack_public_path__ + "static/media/icon_metafek.46f3d19bff946d6ec142423b6bc3a8b9.svg";
export { ForwardRef as ReactComponent };